"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var manager = void 0;

var setUserManager = exports.setUserManager = function setUserManager(userManager) {
  manager = userManager;
};

var userManager = exports.userManager = function userManager() {
  return manager;
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/OidcUserManager.js
// module id = 62
// module chunks = 10